<template>
  <div class="list-page-shell">
    <div v-if="$slots.filters || $slots.actions" class="list-page-shell__bar">
      <div v-if="$slots.filters" class="list-page-shell__bar-filters">
        <slot name="filters" />
      </div>
      <div v-if="$slots.actions" class="list-page-shell__bar-actions">
        <slot name="actions" />
      </div>
    </div>

    <div class="list-page-shell__body">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListPageShell'
}
</script>

<style scoped>
.list-page-shell {
  padding: 16px 24px 32px;
}

.list-page-shell__bar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  padding: 12px 14px;
  border-radius: 8px;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
}

.list-page-shell__bar-filters {
  flex: 1;
  min-width: 0;
}

.list-page-shell__bar-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-shrink: 0;
  margin-left: auto;
}

.list-page-shell__body {
  border-radius: 8px;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  padding: 12px 14px 16px;
  box-shadow: var(--shadow-card);
}

@media (max-width: 900px) {
  .list-page-shell {
    padding: 12px 14px 24px;
  }

  .list-page-shell__bar {
    flex-wrap: wrap;
    align-items: flex-start;
  }

  .list-page-shell__bar-filters {
    flex-basis: 100%;
  }

  .list-page-shell__bar-actions {
    width: 100%;
    justify-content: flex-start;
    margin-left: 0;
  }
}
</style>
